import { config } from '@/config';
import { request as umiRequest } from '@umijs/max';

export const request = <T = any>(url: string, options: any = {}) => {
  return umiRequest<T>(url, {
    ...options,
    baseURL: config.hostApiTransit,
  }) as Promise<T>;
};
